export const stringAvatar = (name: string) => {
  return {
    sx: { cursor: 'pointer' },
    children: `${name[0]}`.toUpperCase(),
  }
}
